import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getIsLoggedIn } from 'Store/User/selectors';
import { OrderPage } from 'Store/Order/enums';
import { fetchCurrentUser } from 'Store/User/thunks';
import { createOrder, fetchCurrentOrder } from 'Store/Order/thunks';
import OrderDetailsPage from 'Pages/OrderDetailsPage/OrderDetailsPage';

import { 
  getOrderRequest, 
  getIsFetchingOrder, 
  getIsFetchOrderFailed, 
  getIsDeliverySelected,
  getIsCustomerSelected,
  getIsRetry,
  getNumberOfOrderSeats,
  getNumberOfOrderVouchers,
  getIsOrderSeatsEmpty,
  getIsOrderVouchersEmpty,
  getOrderIsValid,
} from 'Store/Order/selectors';

interface IPropsInternal {
  isRetry: boolean;
  isFetching: boolean;
  isFetchFailed: boolean;
  isLoggedIn: boolean;
  isDeliverySet: boolean;
  isCustomerSet: boolean;
  isOrderSeatsEmpty: boolean;
  isOrderVouchersEmpty: boolean;
  orderRequest: Julius.Website.OrderRequestViewModel;
  fetchCurrentUser: () => void;
  fetchCurrentOrder: () => void;
  createOrder: (orderRequest: Julius.Website.OrderRequestViewModel) => void;
  isValid: boolean;
}

type Props = IPropsInternal & RouteComponentProps<{ orderItemID: string }>;

interface IState {
  isShowingWarning: boolean;
}

class OrderDetailsPageContainer extends React.PureComponent<Props, IState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShowingWarning: false,
    }
  }

  componentDidMount() {
    const { orderRequest, match } = this.props;
    const performanceID = parseInt(match.params.orderItemID, 10);

    if (
      orderRequest.isManualReservation || 
      orderRequest.seatRequests.length > 0 ||
      orderRequest.voucherRequests.length > 0
    ) {
      this.props.createOrder({
        ...orderRequest,
        performanceID,
      });
    } else {
      this.props.fetchCurrentOrder();
    }

    this.props.fetchCurrentUser();
  }

  componentWillReceiveProps(nextProps: Props) {
    const nextIsDeliverySet = nextProps.isDeliverySet;
    const nextIsCustomerSet = nextProps.isCustomerSet;
    const prevIsShowingWarning = this.state.isShowingWarning;
    let nextIsShowingWarning = prevIsShowingWarning;

    if (prevIsShowingWarning && nextIsDeliverySet && nextIsCustomerSet) {
      nextIsShowingWarning = false;
    }

    this.setState({
      isShowingWarning: nextIsShowingWarning,
    });
  }

  onNext = () => {
    const { isCustomerSet, isDeliverySet } = this.props;

    if (isCustomerSet && isDeliverySet) {
      this.redirectTo(OrderPage.PAYMENT);
    } else {
      this.setState({ isShowingWarning: true });
    }
  }

  onBack = () => {
    this.redirectTo(OrderPage.START);
  }

  redirectTo = (page: string) => {
    const { history, match: { params: { orderItemID } } } = this.props;
    history.replace(`/order/${ orderItemID }${ page }`);
  }

  render() {
    return (
      <OrderDetailsPage 
        isRetry={ this.props.isRetry }
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        isLoggedIn={ this.props.isLoggedIn }
        isShowingWarning={ this.state.isShowingWarning }
        isDeliverySet={ this.props.isDeliverySet }
        isOrderSeatsEmpty={ this.props.isOrderSeatsEmpty }
        isOrderVouchersEmpty={ this.props.isOrderVouchersEmpty }
        isOrderValid={ this.props.isValid }
        onNext={ this.onNext }
        onBack={ this.onBack }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isRetry: getIsRetry(state),
    isFetching: getIsFetchingOrder(state),
    isFetchFailed: getIsFetchOrderFailed(state),
    isLoggedIn: getIsLoggedIn(state),
    isDeliverySet: getIsDeliverySelected(state),
    isCustomerSet: getIsCustomerSelected(state),
    isOrderSeatsEmpty: getIsOrderSeatsEmpty(state),
    isOrderVouchersEmpty: getIsOrderVouchersEmpty(state),
    orderRequest: getOrderRequest(state),
    isValid: getOrderIsValid(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    createOrder,
    fetchCurrentUser,
    fetchCurrentOrder,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderDetailsPageContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderDetailsPage/OrderDetailsPageContainer.tsx